import { apiClient } from '@/plugins/api'

export default {
  sendMessage(payload, config = {}) {
    return apiClient.post(`llm/message`, payload, config);
  },
}
